<template>
  <div
    class="aside-scrollable courses"
    :class="accordionClasses"
  >
    <div
      class="aside-menu__title"
      @click="toggleAccordion"
    >
      {{ $t('courses') }}
      <span class="aside-menu__arrow-box"></span>
    </div>
    <vue-custom-scrollbar class="accordion scroll-area">
      <ul
        id="main-menu"
        class="aside-menu"
      >
        <li
          class="has-sub"
          @click="hideSidebar"
        >
          <router-link to="/">
            <img
              class="aside-menu__icon"
              :src="env.public_base + '/assets/images/dashboard-icon.svg'"
              alt
            />
            <span class="title">{{$t('dashboard')}}</span>
          </router-link>
        </li>

        <app-left-panel-course
          v-for="course in stubCourses"
          :course="course"
          :key="course.id"
        ></app-left-panel-course>
      </ul>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LeftPanelCourse from './LeftPanelCourse';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import env from '../../env';

export default {
  data: () => ({
    env,
    isOpen: true,
    stubCourses: [

      {
          id: 1,
          name: '',
          icon: '/static/front-end/public/assets/images/book-icon--gray.svg',
          route: 'diary'
      },
      {
          id: 2,
          name: '',
          icon: null,
          route: 'curators'
      },

      {
          id: 3,
          name: '',
          icon: null,
          route: 'profile',
      },
    ],
  }),
  components: {
    appLeftPanelCourse: LeftPanelCourse,
    vueCustomScrollbar: vueCustomScrollbar,
  },
  methods: {
    ...mapActions(['toggleSidebarLeft']),
    hideSidebar() {
      const ww = window.innerWidth;

      if (ww < 768) this.toggleSidebarLeft(false);
    },
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
  },
  computed: {
    ...mapGetters([
        'userData',
        'students_payer_billed'
    ]),
    students() {
        return this.students_payer_billed && typeof this.students_payer_billed.length ? this.students_payer_billed : false
    },
    accordionClasses: function() {
      return {
        'is-closed': !this.isOpen,
        'is-primary': this.isOpen,
      };
    },
  },
  created() {
    this.stubCourses[0].name = this.$i18n.messages[this.$i18n.locale].diary;
    this.stubCourses[1].name = this.$i18n.messages[this.$i18n.locale].curators;
    this.stubCourses[2].name = this.$i18n.messages[this.$i18n.locale].profile;

    if ((this.userData.role === 'billing' || this.userData.role === 'student/billing') && this.students.length) {
      this.stubCourses.push({
        id: 4,
        name: this.$i18n.messages[this.$i18n.locale].documents,
        icon: '/static/front-end/public/assets/images/doc-icon--gray.svg',
        route: 'documents',
        toSign: this.userData.to_sign || 0,
      });

      // this.stubCourses[2].toSign = this.userData.to_sign || 0;
    }
  },
};
</script>

<style scoped>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 100%;
  max-height: 290px;
}

.has-sub.documents ::v-deep .aside-menu__icon {
  height: 21px;
}
</style>
